import '../css/style.scss'

(function ($, Drupal, drupalSettings) {
    Drupal.behaviors.selfService = {
        attach: function (context, settings) {
            const submitBtn = document.getElementById('submit_options');

            $('#submitBusinessId').click(function() {
                let _this = this;
                $('.apply-business-id span.error').hide().html('');
                $(_this).find('span:first-child').hide();
                $(_this).find('.loading-dots').fadeIn();
                let data = $('.apply-business-id input').serialize();
                $.post(
                    '/client-self-service/apply-business-id',
                    data,
                    function (resp) {
                        if (typeof resp !== 'undefined' && resp.status !== undefined && resp.status === 'success') {
                            window.location = '?step=continue';
                        } else {
                            $(_this).find('span:first-child').fadeIn();
                            $(_this).find('.loading-dots').hide();
                            if (resp.error !== undefined) {
                                $('.apply-business-id span.error')
                                    .html(resp.error)
                                    .fadeIn()
                                    .css("display","inline-block");;
                            }
                        }
                    }
                );
            });

            if (document.querySelectorAll('input[type=\'checkbox\']').length) {
                $('input[type=\'checkbox\']:not([name=to_invoicing_email])').on('change', function() {
                    if ($('input[type=\'checkbox\']').serialize() !== '') {
                        submitBtn.classList.remove('disabled-btn')
                    } else {
                        submitBtn.classList.add('disabled-btn')
                    }
                })
            }

            window.onOptionsSubmit = (token) => {
                let _this = $('#submit_options');
                if (submitBtn.classList.contains('disabled-btn')) {
                    return false;
                }
                $('.apply-business-id span.error').hide().html('');
                $(_this).find('span:first-child').hide();

                $(_this).find('.loading-dots').fadeIn();
                let data = $('.second-step input').serialize();
                $.post(
                    '/client-self-service/submit',
                    data,
                    function (resp) {
                        if (typeof resp !== 'undefined' && resp.status !== undefined && resp.status === 'success') {
                            window.location = _this.data('url');
                        } else {
                            $(_this).find('span:first-child').fadeIn();
                            $(_this).find('.loading-dots').hide();
                            if (resp.error !== undefined) {
                                // $('.apply-business-id span.error')
                                //     .html(resp.error)
                                //     .fadeIn()
                                //     .css("display","inline-block");
                            }
                        }
                    }
                );
            };
            let schema = 'en';
            if (drupalSettings.scheme !== undefined) {
                schema = drupalSettings.scheme;
                if (schema === 'se') {
                    schema = 'sv';
                }
            }
            const options = $.extend(
                {
                    // numberOfMonths: 2,
                    // showButtonPanel: true
                },
                $.datepicker.regional[schema],
                {dateFormat: 'yy-mm-dd'}
            );
            $.datepicker.setDefaults(options);
            $(".calendar-inputs #from_date, .calendar-inputs #to_date").datepicker();
            $('#to_date, #from_date').change(function(e) {
                if ($('#to_date').val() !== "" && $('#from_date').val() !== "") {
                    if (new Date($('#from_date').val()) > new Date($('#to_date').val())) {
                        $('.form-item-audit-report .error').fadeIn();
                    } else {
                        $('.form-item-audit-report .error').fadeOut();
                    }
                }
            });
            $('.form-item-audit-report label').on('click', function() {
                if ($('.form-item-audit-report input').is(':checked')) {
                    $('.form-item-audit-report .error').fadeOut();
                }
                $('.calendar-inputs').toggleClass('hidden');
            });
        }
    }
})(jQuery, Drupal, drupalSettings);
